import React from 'react';
import {
  ActivityIndicator,
  Alert,
  Modal,
  StyleProp,
  Text,
  TextStyle,
  View,
  ViewStyle,
} from 'react-native';

import {buttonsStyles} from '../../Button/boutonStyle';
import PrimaryButton from '../../Button/PrimaryButton';
import {styles} from './styles.web';

interface Props {
  content?: string;
  title?: string;
  btn1?: string;
  btn2?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleBtn1?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleBtn2?: any;
  loader?: boolean;
  children?: React.ReactNode;
  contentStyle?: StyleProp<TextStyle>;
  modalViewStyle?: StyleProp<ViewStyle>;
  titleStyle?: StyleProp<ViewStyle>;
}

const ConfirmationModal = ({
  content,
  title,
  handleBtn1,
  handleBtn2,
  btn1,
  btn2,
  loader,
  children,
  contentStyle,
  modalViewStyle,
  titleStyle,
}: Props) => {
  return (
    <Modal
      style={styles.webModal}
      animationType="slide"
      transparent={true}
      visible={true}
      onRequestClose={() => {
        Alert.alert('Modal has been closed.');
      }}>
      <View style={styles.modalBlock}>
        <View style={[styles.modalView, modalViewStyle]}>
          <Text style={[styles.modalText, styles.bold, titleStyle]}>
            {title}
          </Text>
          <Text style={[styles.modalText, contentStyle]}>{content}</Text>
          {children}

          <View style={styles.displayHorizontal}>
            {btn2 && (
              <PrimaryButton
                onPress={handleBtn2}
                styleBtnTxt={[buttonsStyles.btnAnnuler, styles.btnStylesTxt]}
                styleBtnOuter={[
                  buttonsStyles.btnAnnulerOuter,
                  styles.btnStyles,
                ]}
                title={btn2}
                type="annuler"
              />
            )}
            {btn1 &&
              (loader ? (
                <View
                  style={{
                    width: '50%',
                  }}>
                  <ActivityIndicator size="large" color="#1D5C42" />
                </View>
              ) : (
                <PrimaryButton
                  onPress={handleBtn1}
                  styleBtnTxt={[
                    buttonsStyles.btnValider,
                    styles.btnStylesTxt,
                    {color: '#fff'},
                  ]}
                  styleBtnOuter={[
                    buttonsStyles.btnValiderOuter,
                    styles.btnStyles,
                  ]}
                  title={btn1}
                  type="valider"
                />
              ))}
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default ConfirmationModal;
